// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.i01Hdr6lmAHVfs {
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
  padding: var(--ds-space-025, 2px) var(--ds-space-100, 8px);
  border-radius: 20px;
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
  color: var(--accent-text, var(--ds-text-subtle, #44546f));
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, normal);
  line-height: 20px;
  /* stylelint-disable plugin/no-unused-selectors */
  /* stylelint-enable plugin/no-unused-selectors */
}
.ufrhLYGjJx_Mee {
  background-color: var(--ds-background-accent-green-subtle, #4bce97);
  color: var(--accent-text-bolder, inherit);
}
.jUvC04JdwY3wBP {
  background-color: var(--ds-background-accent-yellow-subtle, #f5cd47);
  color: var(--accent-text-bolder, inherit);
}
.ut5NcGmjmt7Ui3 {
  background-color: var(--ds-background-accent-orange-subtle, #fea362);
  color: var(--accent-text-bolder, inherit);
}
.uv2jOfMxX0AiOm {
  background-color: var(--ds-background-accent-red-subtle, #f87168);
  color: var(--accent-text-bolder, inherit);
}
.iLMVQbO6O7ckaN {
  background-color: var(--ds-background-accent-purple-subtle, #9f8fef);
  color: var(--accent-text-bolder, inherit);
}
.VQ89kiCOcZKu4p {
  background-color: var(--ds-background-accent-blue-subtle, #579dff);
  color: var(--accent-text-bolder, inherit);
}
.cOybnuvpx1b3Y3 {
  background-color: var(--ds-background-accent-teal-subtle, #6cc3e0);
  color: var(--accent-text-bolder, inherit);
}
.uvejIphhEXtJYe {
  background-color: var(--ds-background-accent-lime-subtle, #94c748);
  color: var(--accent-text-bolder, inherit);
}
.ViaJ8UdPLd2gR2 {
  background-color: var(--ds-background-accent-magenta-subtle, #e774bb);
  color: var(--accent-text-bolder, inherit);
}
.MtyJMXGzdFZE_0 {
  background-color: var(--ds-background-warning-bold, #e2b203);
  color: var(--ds-text-warning-inverse, #172b4d);
}
`, ""]);
// Exports
export var badge = `i01Hdr6lmAHVfs`;
var _1 = `ufrhLYGjJx_Mee`;
export { _1 as "badge--green" };
var _2 = `jUvC04JdwY3wBP`;
export { _2 as "badge--yellow" };
var _3 = `ut5NcGmjmt7Ui3`;
export { _3 as "badge--orange" };
var _4 = `uv2jOfMxX0AiOm`;
export { _4 as "badge--red" };
var _5 = `iLMVQbO6O7ckaN`;
export { _5 as "badge--purple" };
var _6 = `VQ89kiCOcZKu4p`;
export { _6 as "badge--blue" };
var _7 = `cOybnuvpx1b3Y3`;
export { _7 as "badge--teal" };
var _8 = `uvejIphhEXtJYe`;
export { _8 as "badge--lime" };
var _9 = `ViaJ8UdPLd2gR2`;
export { _9 as "badge--magenta" };
var _a = `MtyJMXGzdFZE_0`;
export { _a as "badge--warning" };
export default ___CSS_LOADER_EXPORT___;
